import { Model } from '@/models/Model';
export class GroupUserSubject extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GroupUserSubject';
        this.$endpoint = 'groups/{user}/subjects';
        this.$fillable = [];
    }
    user(userId) {
        this.$endpoint = `groups/${userId}/subjects`;
        return this;
    }
}
